import { message, Radio } from 'antd';
import React from 'react';
import { downloadBulkUpdateShipmentShampleExcel, postBulkUpdateShipment } from 'src/api/shipmentExecution';
import FailureArrayHandleRfq from 'src/components/common/FailureArrayHandleRfq';
import SEBulkExcelUpdate from 'src/components/common/SEBulkExcelUpdate';
import useS3Upload from 'src/hooks/useS3Upload';
import { OrgTypes } from 'src/Library/Constants';
import { useGenericState } from 'src/Library/UseGenericState';
import { downloadFileData } from 'src/utils/utils';
import { REQUEST_STATUS } from '../BulkRequest/BulkRequestUtils';
import { SEFiltersType } from './SE.Types';
import GetExecutionData from 'src/dto/response/getExecution';

export interface SEBulkUpdateProps {
  filters: SEFiltersType;
  type: string;
  getRequestObject: (params: {
      fileName: string,
      id: string | number,
      status: REQUEST_STATUS,
  }) => void;
  s3UploadMap: any[];
  setS3UploadMap: (data: any[]) => void;
  isLoading: boolean;
  setIsLoading: (data: boolean) => void;
  fileName: string;
  setFileName: (data: string) => void;
  isErrorModalVisible: boolean;
  errorData: any[];
  selectedDocuments?: string[];
}

interface SEBulkUpdateState {
}

export default function SEBulkUpdate(props: SEBulkUpdateProps) {
  const { getRequestObject, filters, s3UploadMap, setS3UploadMap, isLoading, setIsLoading, fileName, setFileName, isErrorModalVisible, errorData, selectedDocuments } = props;

  const initialState = {
    fileName: '',
    isLoading: false,
    orgType: OrgTypes.SHIPPER,
  };

  const [state, setState] = useGenericState<SEBulkUpdateState>(initialState);
  const uploadFileToS3Api = useS3Upload('shipment-execution');

  React.useEffect(() => {
    if (!uploadFileToS3Api.uploadState.isUploading && uploadFileToS3Api.uploadState.s3File.s3Link) {
      setS3UploadMap([uploadFileToS3Api.uploadState.s3File.s3Link])
      setFileName(uploadFileToS3Api.uploadState.s3File.name)
      setIsLoading(false);
    }
  }, [uploadFileToS3Api.uploadState.isUploading]);

  const handleDownloadShampleExcel = React.useCallback(async () => {
    if (isLoading) {
      message.warning("Please wait");
      return;
    }
    
    const downloadResponse = await downloadBulkUpdateShipmentShampleExcel({
      viewType: props.type,
      shipmentIdList: selectedDocuments,
    });
    if (downloadResponse.isSuccess) {
      downloadFileData(
        downloadResponse.data,
        downloadResponse.filename,
        true
      );
      message.success('Downloaded successfully');
    } else {
      message.error(downloadResponse.errorMessage);
    }
  }, [isLoading, props.type, selectedDocuments]);

  const getS3UploadLink = React.useCallback(async (fileArray) => {
    if (fileArray?.length) {
      setIsLoading(true);
      await uploadFileToS3Api.uploadToS3(fileArray[0]);
    }
  }, [uploadFileToS3Api]);

  const handleSubmitLinks = async () => {
    if (!s3UploadMap?.length) {
      message.error('Please Upload a file');
      return;
    }
    setIsLoading(true);
    const getLinks = s3UploadMap;
    const payload = {
      awsUrl: getLinks?.pop(),
      fileName,
    };
    const response = await postBulkUpdateShipment(payload);
    if (response.isSuccess) {
      if (response?.data?.failureArray?.length) {
        const errorArray = response?.data?.failureArray
        return;
      } else {
        message.success('Tasks(s) updated successfully.');
        getRequestObject({
          fileName,
          id: response.data?.data?.requestId,
          status: REQUEST_STATUS.PENDING,
        })
      } 
    } else {
      if (response?.data?.failureArray?.length) {
      } else if (response?.errorMessage) {
        message.error(response?.errorMessage);
      }
    }
    setIsLoading(false);
  };

  return (
    <SEBulkExcelUpdate
      headerTextExcelUpload={'Select excel file'}
      isVisible={true}
      title={'Bulk update task'}
      okText={'Submit'}
      isLoading={isLoading}
      sampleLinkInfoText="Download sample excel"
      isMultiple={false}
      handleOnCancel={() => {
      }}
      handleRemoveFile={() => {setS3UploadMap([])}}
      handleSubmit={handleSubmitLinks}
      handlleFileData={(data: any) => {
        getS3UploadLink(data);
      }}
      errorHtml={() => (
        <FailureArrayHandleRfq
          id={'row'}
          failureArray={errorData}
          isVisible={isErrorModalVisible}
        ></FailureArrayHandleRfq>
      )}
      showErrorHtml={isErrorModalVisible}
      handleSampleDownloadLink={handleDownloadShampleExcel}
    />
  );
}
